import script from "./ArtworkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtworkModal.vue?vue&type=script&setup=true&lang=js"

import "./ArtworkModal.vue?vue&type=style&index=0&id=5cf93ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf93ca0"]])

export default __exports__